/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { AuthContext } from 'contexts';
import React from 'react';
import styled from 'styled-components';
import { Input, Button, DatePicker } from 'components';

const ExpireListings: React.FC<{
  fire: (payload: any) => Promise<void>;
}> = ({ fire }) => {
  const { auth } = React.useContext(AuthContext);

  const [location, setLocation] = React.useState(auth!.location);
  const [address, setAddress] = React.useState(auth!.address);
  const [orgId, setOrgId] = React.useState(auth!.org.id);
  const [timeToExpire, setTimeToExpire] = React.useState(new Date());

  const handleFire = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    fire({
      location,
      address,
      orgId,
      timestamp: timeToExpire.toString(),
    });
  };

  return (
    <StyledForm onSubmit={handleFire}>
      <Input
        label="Location (Listing's branch index)"
        onChange={e => setLocation(e.target.value)}
        defaultValue={auth!.location}
      />
      <Input
        label="Address (Listing's office index)"
        onChange={e => setAddress(e.target.value)}
        defaultValue={auth!.address}
      />
      <Input
        label="Org id"
        onChange={e => setAddress(e.target.value)}
        defaultValue={auth!.org.id}
      />
      <DatePicker
        label="Time to expire (Available listings with an expiry before this date will become expired)"
        value={timeToExpire}
        onChange={date => (date ? setTimeToExpire(date) : null)}
        format="MMM D, YYYY HH:mm"
        picker="date"
      />
      <Button htmlType="submit">Fire</Button>
    </StyledForm>
  );
};

const StyledForm = styled.form`
  width: 750px;
  display: grid;
  grid-gap: 15px;
`;

export default ExpireListings;
